<script lang="ts" setup>
import { computed } from 'vue'
import { PhArrowRight } from '@phosphor-icons/vue'

import { usePageStore } from '@toni/rendering/src/stores/page'
import { BlockContainer, TableOfContentHeader } from '@toni/brand-ui'

import TableOfContent from './TableOfContent.vue'
import { useContentBlock } from '../../../content-blocks/composables/use-content-block.ts'
import { usePageBlockWidth } from '../../../composables/use-page-block-width.ts'

const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'tableOfContents')

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
const isHorizontal = computed(() => contentBlock.value.data.tableOfContents.items.length <= 5)
</script>

<template>
  <BlockContainer :size="size"
                  class="mb-6 md:mb-8">
    <TableOfContent :items="contentBlock.data.tableOfContents.items"
                    tw-class="gap-6 md:gap-8">
      <template #header>
        <TableOfContentHeader class="relative uppercase pt-4 before:block before:absolute before:top-0 before:left-0 before:w-[88px] before:h-2 before:bg-accent-quarternary">
          {{ contentBlock.data.tableOfContents.title }}
        </TableOfContentHeader>
      </template>
      <template #icon>
        <span v-if="!isHorizontal"
              class="flex-shrink-0">
          <PhArrowRight weight="bold"
                        class="w-4 md:w-5 h-4 md:h-5" />
        </span>
      </template>
    </TableOfContent>
  </BlockContainer>
</template>
